import React from "react";
import PropTypes from "prop-types";

import "./Warn.css";
import WarnIcon from "./warn-icon.png";

const Warn = (props) => {
  Warn.propTypes = {
    children: PropTypes.node,
    icon: PropTypes.string,
    className: PropTypes.string,
  };

  return (
    <div
      className={
        props.className ? `${props.className} warn-container` : "warn-container"
      }>
      <span className="warn-img-container">
        <img
          className="warn-icon"
          src={props.icon ? props.icon : WarnIcon}
          alt="!"
        />
      </span>
      {props.children ? props.children : null}
    </div>
  );
};

export default Warn;
